import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Loader } from '../../components/util/Svg';
import LastActive from '../../components/util/LastActive';
import { getSortIndicator } from './userListQuery';

const SortableHeader = ({ label, columnKey, sortBy, sortOrder, onSort }) => {
    const activeSortBy = sortBy || 'created';
    const activeSortOrder = sortOrder || 'desc';
    const isActive = activeSortBy === columnKey;
    const indicator = getSortIndicator(activeSortBy, activeSortOrder, columnKey);

    return (
        <th
            onClick={() => onSort(columnKey)}
            style={{
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                color: isActive ? '#212529' : undefined,
                fontWeight: isActive ? 700 : undefined,
            }}
            title="Click to sort"
        >
            {label}
            <span style={{ opacity: isActive ? 1 : 0.45, marginLeft: 4 }}>{indicator.trim()}</span>
        </th>
    );
};

const UsersTable = ({
    list,
    loader,
    page,
    limit,
    sortBy,
    sortOrder,
    onSort,
    onSelect,
    showSubscriptionPlan = true,
}) => (
    <div className="table-responsive cm_card px-3 py-0 mb-3 cm_table_min_height">
        {loader ? <div className="loader_lg"><Loader /></div> : ''}
        <table className="table user-table table-hover align-items-center">
            <thead>
                <tr>
                    <th>S.No.</th>
                    <SortableHeader label="Name" columnKey="fullName" sortBy={sortBy} sortOrder={sortOrder} onSort={onSort} />
                    <SortableHeader label="Email" columnKey="email" sortBy={sortBy} sortOrder={sortOrder} onSort={onSort} />
                    <SortableHeader label="Created" columnKey="created" sortBy={sortBy} sortOrder={sortOrder} onSort={onSort} />
                    <th>Company name</th>
                    <th>Credits left</th>
                    <th>Auto refill</th>
                    <th>Show Credit</th>
                    <th>Active Subscribers</th>
                    {showSubscriptionPlan ? <th>Subscription Plan</th> : ''}
                    <SortableHeader label="Mobile number" columnKey="phone" sortBy={sortBy} sortOrder={sortOrder} onSort={onSort} />
                    <SortableHeader label="Last Active" columnKey="lastActive" sortBy={sortBy} sortOrder={sortOrder} onSort={onSort} />
                    <th>Cars created</th>
                    {!showSubscriptionPlan ? <th>Subscription Plan</th> : ''}
                    <SortableHeader label="Status" columnKey="userStatus" sortBy={sortBy} sortOrder={sortOrder} onSort={onSort} />
                    <SortableHeader label="Updated" columnKey="updated" sortBy={sortBy} sortOrder={sortOrder} onSort={onSort} />
                </tr>
            </thead>
            <tbody>
                {list.map((item, i) => (
                    <tr key={item._id}>
                        <td>{((i + 1) + ((page - 1) * limit))}</td>
                        <td>
                            <Link to={`/userdetail/${item._id}`}>
                                <div className="d-inline-block align-middle">
                                    <span className="font-weight-bold">{item.fullName}</span>
                                    <div className="small text-muted">{item._id}</div>
                                </div>
                            </Link>
                        </td>
                        <td>{item.email || '-'}</td>
                        <td>{item.created ? moment(item.created).format('DD MMM, YYYY') : '-'}</td>
                        <td>
                            {item.companyDetails && item.companyDetails.companyName
                                ? item.companyDetails.companyName
                                : item.companyName || '-'}
                        </td>
                        <td>{item.leftPackCredits ? item.leftPackCredits : 0}</td>
                        <td>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={item.thresholdRefillStatus === 1}
                                    onChange={(e) => onSelect(e, item._id, 2, item.thresholdRefillStatus)}
                                />
                                <span className="slider round"></span>
                            </label>
                        </td>
                        <td>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={item.showCredit === true}
                                    onChange={(e) => onSelect(e, item._id, 5, item.showCredit)}
                                />
                                <span className="slider round"></span>
                            </label>
                        </td>
                        <td>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={item.isActiveSubscriber === 1}
                                    onChange={(e) => onSelect(e, item._id, 4, item.isActiveSubscriber)}
                                />
                                <span className="slider round"></span>
                            </label>
                        </td>
                        {showSubscriptionPlan ? (
                            <td>{item.subscriptionPlan ? item.subscriptionPlan : ''}</td>
                        ) : ''}
                        <td>
                            {item.countryCode ? item.countryCode : ''}{' '}
                            {item.phone ? item.phone : item.phoneNumber ? item.phoneNumber : ''}
                        </td>
                        <td>{item.lastActive ? <LastActive timestamp={item.lastActive} /> : ''}</td>
                        <td>{item.carCount}</td>
                        {!showSubscriptionPlan ? (
                            <td>{item.subscriptionPlan ? item.subscriptionPlan : ''}</td>
                        ) : ''}
                        <td>
                            <span className={item.userStatus === 1 ? 'text-success' : 'text-muted'}>
                                {item.userStatus === 1 ? 'Active' : 'Inactive'}
                            </span>
                        </td>
                        <td>{item.updated ? moment(item.updated).format('DD MMM, YYYY') : '-'}</td>
                    </tr>
                ))}
            </tbody>
        </table>

        {!loader && !list.length ? <h5 className="text-center py-4">No users found</h5> : ''}
    </div>
);

export default UsersTable;
